import autocomplete from '@/components/autocomplete/index.vue'



import {mapGetters, mapMutations} from "vuex";




export default {
  name: 'delivery-courier',
  props:['street'],

  data() {
    return {

      isValidTown: false,
      payload: {
        town: 'Київ',
        houseNumber: '',
        street: '',
        flatNumber: ''
      },

    }
  },
  components: {
    autocomplete
  },

  computed: {
    ...mapGetters({
      addressData: 'order/address',
      towns: 'order/towns',
    }),

  },
  created() {
    console.log(this.$route.params.lang)
  },
  methods: {
    ...mapMutations({
      changeAddressData: 'order/CHANGE_ADDRESS'
    }),
    onRequestTown(val) {
      const formData = JSON.stringify({
        "modelName": "Address",
        "calledMethod": "getCities",
        "methodProperties": {
          "FindByString": val,

        },
        "apiKey": "fabe6d1af4bb606c075d48052cd8bf83"
      })
      this.fetchTowns(formData).then(() => {
        const currentTown = this.towns.find(e => e.Description === this.town)
        this.department = ''

        if (!currentTown) {
          return
        }

        if (this.town === currentTown.Description) {
          this.onRequestDepartments('')
        } else {
          this.setDepartments([])
        }
        this.checkValidData()
      })
    },
    onRequestDepartments(val) {
      const formData = JSON.stringify({
        "modelName": "AddressGeneral",
        "calledMethod": "getWarehouses",
        "methodProperties": {
          "CityName": this.town,
          "FindByString": val,

        },
        "apiKey": "fabe6d1af4bb606c075d48052cd8bf83"
      })
      this.fetchDepartments(formData).then(() => {
        this.checkValidData()
      })
    },
    checkValidData() {
      const currentTown = this.towns.find(e => e.Description === this.town)
      if (currentTown) {
        this.isValidTown = this.town === currentTown.Description && this.town.length !== 0
      } else {
        // this.isValidTown = false
      }

      const currentDepartment = this.departments.find(e => e.Description === this.department)
      if (currentDepartment) {
        this.isValidDepartment = this.department === currentDepartment.Description && this.department.length !== 0
      } else {
        this.isValidDepartment = false
      }

      this.isValid = this.isValidTown && this.isValidDepartment
      this.changeAddress({ town: this.town, department: this.department })
      this.$emit('input', this.isValid)
    }
  }
}
